const version = "Kardemummakaka 2026-06-16";

export default version;
